export default __webpack_public_path__ + "static/media/joint-dynamics.591ccaf8.png";